<template>
  <section class="foyer">
    <div class="background-container">
      <Header v-if="!hideHeader" @headerRouteClicked="sendReturnMessage" @userStateChanged="userStateChanged" />
      <iframe v-show="showFrame" class="foyer-iframe" id="the_iframe" ref="the_iframe" :src="foyerSrc" frameborder="0"></iframe>
    </div>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';

export default {
  name: 'FoyerLevels',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      hideHeader: true,
      footerKey: 0,
      showFrame: true,
      setZ: false,
      activityData: {},
      srcLevels: [],
      currentUserLevel: 0,
    };
  },

  computed: {
    mainActivity() {
      if (this.$store.state.availableActivities.length == 1) {
        return {
          name: 'Activity',
          params: {
            stream: this.$store.state.availableActivities[0].activity_id,
          },
        };
      } else {
        return {
          name: 'ActivityList',
        };
      }
    },
    foyerSrc() {
      try {
        if (this.activityData.property?.src && !this.srcLevels.length) return this.activityData.property.src;
        else if (this.srcLevels.length) {
          let level;
          const levels = this.srcLevels.map(e => { return { id: e.id, level: e.level, onlyOnFirstLogin: e.onlyOnFirstLogin, src: e.src } });
          const sameAsUserLevels = levels.filter(e => e.level === this.currentUserLevel);
          const isThereAnyFirstLoginControlledLevel = sameAsUserLevels.filter(e => e.onlyOnFirstLogin).length > 0;

          if (isThereAnyFirstLoginControlledLevel && this.$store.state.user.isFirstLogin) {
            level = sameAsUserLevels.filter(e => e.onlyOnFirstLogin)[0];
          } else if (sameAsUserLevels.length > 0) {
            level = sameAsUserLevels[0];
          } else {
            level = levels[0];
          }

          try {
            const route = JSON.parse(level.src);
            this.showFrame = false;
            this.$router.push(route);
            return '';
          } catch (error) {
            return level.src || '';
          }
        } else return '';
      } catch {
        return this.activityData.property?.src || '';
      }
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },

  methods: {
    sendReturnMessage() {
      // console.log('INFO');
      this.$refs.the_iframe.contentWindow.postMessage('return', '*');
    },
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then(response => {
          //console.log(response);
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          const tempProperty = { src: '', img: '' };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
          this.imageHelp = this.activityData.property.imageHelp;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;

          this.srcLevels = this.activityData.property.srcLevels;
        })
        .catch(err => {
          console.error(err);
        });
    },
    messagesHandler(e) {
      try {
        let received = JSON.parse(e.data);

        if (received.url) {
          window.open(received.url);
          api.post(`sessionAction/`, {
            action: 'Foyer Action - External URL',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        }
        if (received.name) {
          api.post(`sessionAction/`, {
            action: 'Foyer Action - Route',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          this.$router.push(received).catch(err => {
            console.error('navigation error', err);
          });
        }
        if (received.sessionAction) {
          api.post(`sessionAction/`, {
            action: 'Foyer Action - Internal Object',
            properties: JSON.stringify(received),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        }
        // console.log('api.post sessionAction/ ' + e);
      } catch (e) {
        // console.log('Parsing error: ' + e);
      }
    },
    userStateChanged() {
      // console.log('userStateChanged');
      this.currentUserLevel = this.$store.state.user.level;
    },
  },

  beforeMount() {
    this.currentUserLevel = this.$store.state.user.level;
    this.loadActivity();
  },
  mounted() {
    window.addEventListener('message', this.messagesHandler, false);
    this.$nextTick(() => {
      this.footerKey++;
      setTimeout(() => {
        if (this.$refs.the_iframe) this.$refs.the_iframe.focus(); // focus to propagate arrow keys to the iframe
      }, 1000);
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messagesHandler);
  },
};
</script>

<style lang="scss">
</style>